import round from 'helpers/mathRound';


export const getDiscount = (selectedItem, productData) => {
  const {
    qty,
    discount,
    discountType
  } = selectedItem;

  let discountTotal = 0;

  if (Number(productData?.savings)) {
    discountTotal = round(productData.savings * qty) || 0;
  } else if (productData?.discount_options) {
    const selectedDiscountData = productData?.discount_options?.find((option) => Number(option.price) === Number(discount) && option.price_type === discountType) || null;

    if (selectedDiscountData) {
      discountTotal = selectedDiscountData.price_type === 'fixed'
        ? round(Math.abs(selectedDiscountData.price * qty).toFixed(2))
        : round(Math.abs((selectedDiscountData.price * productData.price / 100) * qty).toFixed(2));
    }
  }

  return discountTotal;
};
